import React, { useState,useEffect } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { handleCommission } from '../../Api/Payments/Payments';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import ReactPaginate from "react-js-pagination";
import {Tooltip} from 'antd';

import { IoIosArrowDropupCircle,IoIosArrowDropdownCircle } from 'react-icons/io';

const Commission=()=>{
    const[activePage,setActivePage]=useState(1);
    const [expandedRowKey, setExpandedRowKey] = useState(null);
  const [isRowExpanded, setIsRowExpanded] = useState(false);
  const [updatedata, SetUpdateData] = useState();
  const dispatch=useDispatch();
    const itemsPerPage=10
    const getCommission =
    useSelector((state) => state.crm.commission) || [];
  console.log(getCommission, "commission detail");

// const getCommissionsearch =
//     useSelector((state) => state.crm.commission_search)||;
//   console.log(getCommissionsearch, "commission detail search");

   const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    console.log(activePage, "active page");
    console.log(itemsPerPage, "page items");
    setIsRowExpanded(false);
    
    setExpandedRowKey(null);
  };

//   const formatDate = (dateStr) => {
//   const dateTime = new Date(dateStr);

//   const options = { day: "2-digit", month: "short", year: "numeric" };
//   const formattedDate = dateTime.toLocaleDateString("en-GB", options);

//   const hours = dateTime.getHours().toString().padStart(2, '0');
//   const minutes = dateTime.getMinutes().toString().padStart(2, '0');
//   const hour = hours % 12 || 12; 
//   const ampm=hour>=12?'PM':'AM';
  

//   return `${formattedDate} (${hours}:${minutes} ${ampm})`;
// };
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
  };

  const handleRowClick = (record) => {
    console.log(record, "record");
    SetUpdateData(record.tbs_ticket_no);
    const newExpandedKey = record.key === expandedRowKey ? null : record.key;
    setExpandedRowKey(newExpandedKey);
    console.log(expandedRowKey, "record record");
    setIsRowExpanded(newExpandedKey !== null);
  };
 
  const indexOfLastItem = activePage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  

  const currentItems =  Array.isArray(getCommission)
      ? getCommission.slice(indexOfFirstItem, indexOfLastItem)
      : [getCommission];
//  console.log(currentItems, "leeeeeength");

//  const currentData= getCommissionsearch.slice(indexOfFirstItem, indexOfLastItem)
//  console.log(currentData, "leeeeeength");

    useEffect(() => {
      handleCommission(dispatch)
    }, []);

    const columns = [
    {
      title: (
        <div
          className="text-[1.2vw] text-center font-bold px-[0.1vw]"
          style={{ color: "white" }}
        >
          S.No
        </div>
      ),
      width: "3vw",
      render: (row, rowdta, index) => {
        const serialNumber = (activePage - 1) * itemsPerPage + index + 1;
        
        return (
          <div className="flex justify-center text-[#1F4B7F] text-[1vw] py-[0.5vw] font-bold">
            {serialNumber}
          </div>
        );
      },
    },

    {
      title: (
        <div
          className="text-[1.2vw] text-center font-bold"
          style={{ color: "white" }}
        >
          Ticket Number
        </div>
      ),
      width: "7vw",
      render: (row, rowdta, index) => {
        return (
<p className='flex justify-center text-[#1f4B7F] text-[1vw] font-bold'> {row.ticket}</p>
        );
      },
    },
    {
      title: (
        <div
          className="text-[1.2vw] text-center font-bold"
          style={{ color: "white" }}
        >
       <Tooltip
            placement="top"
            title="Booking Date / Time"
            className="cursor-pointer"
            color="white"
            overlayInnerStyle={{
              color: "#1F487C",
            }}
          >
            Booking D / T
          </Tooltip>
        </div>
      ),
      width: "10vw",
      render: (row, rowdta, index) => {
        return (
<p className='flex justify-center text-[#1f4B7F] text-[1vw] font-medium'> {row?.booking_date?( `${formatDate(
              row.booking_date.split(",")[0]
            )} (${row.booking_date.split(",")[1]})`):"-"}
            </p>
        );
      },
    },
    {
      title: (
        <div
          className="text-[1.2vw] text-center font-bold"
          style={{ color: "white" }}
        >
          Base Fare
        </div>
      ),
      width: "6vw",
      render: (row, rowdta, index) => {
        return (
<p className='flex justify-center text-[#1f4B7F] text-[1vw] font-bold'> ₹ {row.basefare}</p>
        );
      },
    },

    {
      title: (
        <div
          className="text-[1.2vw] text-center font-bold"
          style={{ color: "white" }}
        >
          Commission
        </div>
      ),
      width: "8vw",
      render: (row, rowdta, index) => {
        return (
<p className='flex justify-center text-[#1f4B7F] text-[1vw] font-bold'>₹ {row.commission}</p>
        );
      },
    },
    {
      title: (
        <div
          className="text-[1.2vw] text-center font-bold"
          style={{ color: "white" }}
        >
          Amount Paid
        </div>
      ),
      width: "8vw",
      render: (row, rowdta, index) => {
        return (
          <div className="flex justify-center text-[#1F4B7F] text-center text-[1vw] py-[0.5vw] font-bold">
           ₹ {row.amountpaid}
          </div>
        );
      },
    },
    {
      title: (
        <div
          className="text-[1.2vw] text-center font-bold"
          style={{ color: "white" }}
        >
          Credit Amount
        </div>
      ),
      width: "8vw",
      render: (row, rowdta, index) => {
        return (
          <div className="ml-[2vw] text-[#1F4B7F] text-center  text-[1vw] py-[0.5vw] font-bold">
          ₹  {row.credit_amount}
          </div>
        );
      },
    },
    {
      title: (
        <div className="text-[1.2vw] text-center font-bold text-white flex items-center justify-evenly">
          
            Profit / Loss
          
      </div>
      ),

      width: "8vw",
      render: (row, rowdta, index) => {
        return (
          <div className="ml-[2vw] text-[#1F4B7F] text-center  text-[1vw] py-[0.5vw] font-bold">
           ₹   {
              row.profit_loss
            }
            {/* {
            row.status==="Profit"?
            (<p className='text-green-500'>{row.profit_loss}</p>):row.status==="Loss"?(<p className='text-red-500'>{row.profit_loss}</p>):"-"
          } */}
          </div>
          //  <p className='flex justify-center text-[#1f4B7F] text-[1vw] font-bold'> {row.profit_loss}</p>
        );
      },
    },


    {
      title: (
        <div
          className="text-[1.2vw] text-center font-bold flex justify-evenly items-center"
          style={{ color: "white" }}
        >
          <p>Result</p>
          </div>
      ),


      width: "9vw",
      render: (row, rowdta, index) => {
        return (
          <div className="grid grid-cols-3  text-[#1F4B7F] justify-center text-[1vw] py-[0.5vw] font-bold ml-[1.5vw]">
           <div className='col-span-2 ml-[1vw]'>
            {row.status === "null" ?(
              <p>-</p>
            ) : row.status === "Profit" ? (
              
              <div className="bg-[#34AE2B]  flex justify-center rounded-[0.5vw] text-[1vw]  font-extrabold shadow-md shadow-black text-white w-[5.5vw] py-[0.1vw] text-center">Profit</div>
            ) : row.status === "Loss" ? (
             
              <div className="bg-[#FD3434] rounded-[0.5vw] text-[1vw] font-extrabold shadow-md shadow-black text-white w-[5.5vw] py-[0.1vw] text-center">Loss</div>
            ) :"-"
            }
           </div>
            <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRowClick(row);
                          }}
                          className="col-span-1 ml-[1vw]"
                        >
                          {row.key === expandedRowKey ? (
                            <IoIosArrowDropupCircle
                              style={{ height: "1.3vw", width: "1.3vw" }}
                            />
                          ) : (
                            <IoIosArrowDropdownCircle
                              style={{ height: "1.3vw", width: "1.3vw" }}
                            />
                          )}
                        </button>
          </div>
        );
      },
    },
  ];


  



  const data =
    currentItems?.length > 0 &&
    currentItems?.map((item, index) => ({
      key: item.id,
      s_no: 1,
      
      ticket:item.tbs_ticket_no,
      booking_date:item.booking_date,
      
      basefare:item.StandardCommissionBreakdown.base_fare,
      commission:item.StandardCommissionBreakdown.agent_commission_credit_excl_gst,
      amountpaid:item.Tbsfareandpaltformdiscount.total_fare_paid_by_passenger,
     credit_amount:item.RazorpayChargesonReceivedAmount.net_settlement_from_razorpay,
     profit_loss:item.NetProfitORLossSummary.net_value,
     status:item.NetProfitORLossSummary.status,
     hidden_details: (
        <div className="grid grid-cols-3">
          <div className="col-span-1 border-r-[0.1vw] border-[#1F487C] flex-row ml-[2vw] items-center justify-center py-[0.5vw] text-[0.8vw] mt-[0.1vw]">
            <div className='flex'>
  <h1 className='text-black text-[1.25vw] font-bold mb-[0.8vw] ml-[3vw]'>Abhibus Commission Breakdown</h1>
</div>
<div className='w-[26vw]'>
       <table style={{ borderCollapse: 'collapse', width: '100%' }}>
    <thead>
      <tr className="border-2 border-gray-300 border-b">
        <th className="px-[1vw] text-left text-[1vw] border-r-2 border-gray-300 py-[0.5vw]">Component</th>
        <th className="px-[1vw]  text-right text-[1vw]">
          Amount
        </th>
      </tr>
      </thead>
      <tbody>
              
              
                <tr className="border-2 border-gray-300 border-b">
                  <td className="px-[1vw] py-0.9 font-semibold border-r-2 border-gray-300">Base Fare</td>
                  <td className="px-[1vw] py-0.9 text-right font-semibold"> {Number(item.StandardCommissionBreakdown.base_fare).toFixed(2)}</td>
                  {/* <p>₹ {item?.base_fare.endsWith('0') ? item.base_fare.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '') : item.base_fare}</p> */}
                </tr>
                <tr className="border-2 border-b border-gray-300 ">
                  <td className="px-[1vw] py-0.9 font-semibold border-r-2 border-gray-300">GST @ 5% on Base Fare</td>
                  <td className="px-[1vw] py-0.9 text-right font-semibold">
                     {Number(item.StandardCommissionBreakdown.gst_on_base_fare).toFixed(2)}</td>
                  </tr>
                 
               
                {/* <hr class="border-t-2 border-dotted border-black ml-3 w-[17vw]" /> */}

                <tr className="border-2 border-b border-gray-300">
                  <td className="px-[1vw] py-0.9 font-semibold border-r-2 border-gray-300">Total from Passenger</td>
                  <td className="px-[1vw] py-0.9 text-right font-semibold"> {Number(item.StandardCommissionBreakdown.total_from_passenger).toFixed(2)}</td>
                </tr>
                <tr className="border-2 border-b border-gray-300">
                  <td className="px-[1vw] py-0.9 font-semibold border-r-2 border-gray-300">Commission @ 6.78% of Base Fare</td>
                  <td className="px-[1vw] py-0.9 text-right font-semibold"> {Number(item.StandardCommissionBreakdown.commission_amount).toFixed(2)}</td>
                </tr>
                <tr className="border-2 border-b border-gray-300">
                  <td className="px-[1vw] py-0.9 font-semibold border-r-2 border-gray-300">GST @ 18% on Commission (Service Tax)</td>
                  <td className="px-[1vw] py-0.9 text-right font-semibold"> {Number(item.StandardCommissionBreakdown.gst_on_commission).toFixed(2)}</td>
                </tr>
                <tr className="border-2 border-b border-gray-300">
                  <td className="px-[1vw] py-0.9 font-semibold border-r-2 border-gray-300">Total Commission Payable</td>
                  <td className="px-[1vw] py-0.9 text-right font-semibold">{Number(item.StandardCommissionBreakdown.total_commission_payable).toFixed(2)}</td>
                </tr>
                <tr className="border-2 border-b border-gray-300">
                  <td className="px-[1vw] py-0.9 font-semibold border-r-2 border-gray-300">TDS @ 1.7% on Total Commission</td>
                  <td className="px-[1vw] py-0.9 text-right font-semibold"> - {Number(item.StandardCommissionBreakdown.tds_on_commission).toFixed(2)}</td>
                </tr>
                <tr className="border-2 border-b border-gray-300">
                  <td className="px-[1vw] py-0.9 font-semibold border-r-2 border-gray-300">Final Commission (After TDS)</td>
                  <td className="px-[1vw] py-0.9 text-right font-semibold"> {Number(item.StandardCommissionBreakdown.final_commission_after_tds).toFixed(2)}</td>
                </tr>
                <tr className="border-2 border-b border-gray-300">
                  <td className="px-[1vw] py-0.9 font-semibold border-r-2  border-gray-300 ">Net Amount to be Paid to Agent</td>
                  <td className="px-[1vw] py-0.9 text-right font-semibold "> {Number(item.StandardCommissionBreakdown.net_amount_to_agent).toFixed(2)}</td>
                </tr>
                <tr className="border-2 border-b border-gray-300 ">
                  <td className="px-[1vw] py-0.9 font-semibold border-r-2 border-gray-300 pb-[0.3vw]">Abhibus Wallet Debit</td>
                  <td className="px-[1vw] py-0.9 text-right font-semibold pb-[0.3vw]">  {Number(item.NetProfitORLossSummary.abhibus_wallet_debit).toFixed(2)}</td>
                  {/* <p>₹ {item?.base_fare.endsWith('0') ? item.base_fare.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '') : item.base_fare}</p> */}
                </tr>
                <tr className="bg-[#1F4B7C] text-white font-semibold rounded-b-md text-[1vw]">
        <td className="px-[1vw] py-1.5 rounded-bl-lg font-bold">Agent Commission Credit (Excl. GST)</td>
        <td className="px-[1vw] py-1.5 rounded-br-lg text-right font-bold">
          ₹ {Number(item.StandardCommissionBreakdown.agent_commission_credit_excl_gst).toFixed(2)}
        </td>
      </tr>
                 {/* <tr className="flex justify-between flex-row w-full bg-[#1F4B7C] text-white rounded-b-md  p-2 px-[1vw] ">
                  <td className="font-semibold">Agent Commission Credit (Excl. GST)</td>
                  <td>₹ {Number(item.StandardCommissionBreakdown.agent_commission_credit_excl_gst).toFixed(2)}</td>
                </tr> */}

</tbody>

          </table> 
          </div>
             
            </div>
        
          
          <div className="col-span-1 border-r-[0.1vw] ml-[4vw] border-[#1F487C] flex-row items-center justify-center py-[0.5vw] text-[0.8vw] mt-[1.5vw]">
            <div className='flex'>
  <h1 className='text-black text-[1.25vw] font-bold mb-[1vw] ml-[3vw]'>TBS Fare & Platform Discounts</h1>
</div>
         <div className="w-[24vw] rounded-lg ">
  <table style={{ borderCollapse: 'collapse', width: '100%' ,}}>
    <thead>
      <tr className="border-2 border-b border-gray-300">
        <th className="px-[1vw]  text-left text-[1vw] border-r-2 border-gray-300 py-[0.5vw]">Component</th>
        <th className="px-[1vw] text-right text-[1vw]">
          Amount
        </th>
      </tr>
      </thead>
      <tbody>
      <tr className=" border-2 border-b border-gray-300 ">
        <td className="px-[1vw] py-0.9 font-semibold border-r-2 border-gray-300">TBS Base Fare</td>
        <td className="px-[1vw] py-0.9 text-right font-semibold">
           {Number(item.Tbsfareandpaltformdiscount.tbs_base_fare).toFixed(2)}
        </td>
      </tr>

      <tr className="border-2 border-b border-gray-300">
        <td className="px-[1vw] py-0.9 font-semibold border-r-2 border-gray-300">TBS Deal @ 5%</td>
        <td className="px-[1vw] py-0.9 text-right font-semibold">
           {Number(item.Tbsfareandpaltformdiscount.tbs_deal_5_percent).toFixed(2)}
        </td>
      </tr>

      <tr className="border-2 border-b border-gray-300">
        <td className="px-[1vw] py-0.9 font-semibold border-r-2 border-gray-300">TBS Fare After Disc.</td>
        <td className="px-[1vw] py-0.9 text-right font-semibold">
           {Number(item.Tbsfareandpaltformdiscount.tbs_fare_after_discount).toFixed(2)}
        </td>
      </tr>

      <tr className="border-2 border-b border-gray-300">
        <td className="px-[1vw] py-0.9 font-semibold border-r-2 border-gray-300">TBS GST @ 5%</td>
        <td className="px-[1vw] py-0.9 text-right font-semibold">
           {Number(item.Tbsfareandpaltformdiscount.tbs_gst_5_percent).toFixed(2)}
        </td>
      </tr>

      <tr className="border-2 border-b border-gray-300">
        <td className="px-[1vw] py-0.9 font-semibold border-r-2 border-gray-300">Subtotal (Before Flat Disc.)</td>
        <td className="px-[1vw] py-0.9 text-right font-semibold">
           {Number(item.Tbsfareandpaltformdiscount.tbs_subtotal_before_flat_discount).toFixed(2)}
        </td>
      </tr>

      <tr className="border-2 border-b border-gray-300">
        <td className="px-[1vw] py-0.9 font-semibold border-r-2 border-gray-300 pb-[0.3vw]">Flat Discount (Platform)</td>
        <td className="px-[1vw] py-0.9 text-right font-semibold pb-[0.3vw]">
           {Number(item.Tbsfareandpaltformdiscount.platform_flat_discount).toFixed(2)}
        </td>
      </tr>

      <tr className="bg-[#1F4B7C] text-white font-semibold rounded-b-md text-[1vw]">
        <td className="px-[1vw] py-1.5 rounded-bl-lg font-bold">Total Fare Paid by Passenger</td>
        <td className="px-[1vw] py-1.5 rounded-br-lg text-right font-bold">
          ₹ {Number(item.Tbsfareandpaltformdiscount.total_fare_paid_by_passenger).toFixed(2)}
        </td>
      </tr>
    </tbody>
  </table>
</div>

          </div>



  
                    <div className="row-span-1 ml-[5vw] flex-row items-center justify-center py-[0.5vw] text-[0.8vw] mt-[0.5vw]">
                       <div className='flex'>
  <h1 className='text-black text-[1.25vw] font-bold mb-[0.9vw] ml-[1vw]'>Razorpay Charges / Commission Result</h1>
</div>
<div className="  w-[24vw]">
   <table style={{ borderCollapse: 'collapse', width: '100%',   }}>
    <thead>
      <tr className="border-2 border-b border-gray-300 ">
        <th className="px-[1vw]  text-left text-[1vw] border-r-2 border-gray-300 py-[0.5vw]">Component</th>
        <th className="px-[1vw]  text-right text-[1vw] ">
          Amount
        </th>
      </tr>
      </thead>
    <tbody>
      <tr className="border-2 border-b border-gray-300">
        <td className="px-[1vw] py-0.9 font-semibold border-r-2 border-gray-300">TBS Fare Paid</td>
        <td className="px-[1vw] py-0.9 text-right font-semibold">
           {Number(item.RazorpayChargesonReceivedAmount.total_fare_paid).toFixed(2)}
        </td>
      </tr>

      <tr className="border-2 border-b border-gray-300">
        <td className="px-[1vw] py-0.9 font-semibold border-r-2 border-gray-300 pb-[0.3vw]">Razorpay Charges @ 2%</td>
        <td className="px-[1vw] py-0.9 text-right font-semibold pb-[0.3vw]">
          - {Number(item.RazorpayChargesonReceivedAmount.razorpay_charge_2_percent).toFixed(2)}
        </td>
      </tr>

      <tr className="bg-[#1F4B7C] text-white font-semibold text-[1vw]">
        <td className="px-[1vw] py-1.5  font-bold">Net Settlement from Razorpay</td>
        <td className="px-[1vw] py-1.5  text-right font-bold">
          ₹ {Number(item.RazorpayChargesonReceivedAmount.net_settlement_from_razorpay).toFixed(2)}
        </td>
      </tr>
                     
                <tr className="border-2 border-b border-gray-300 border-t-0">
                  <td className="px-[1vw] py-0.9 font-semibold border-r-2 border-gray-300  pt-[0.3vw]">Net Settlement from Razorpay</td>
                  
                  <td className="px-[1vw] py-0.9 text-right font-semibold  pt-[0.3vw]">  {Number(item.NetProfitORLossSummary.net_settlement_from_razorpay).toFixed(2)}</td>
                </tr>
                
                <tr className="border-2 border-b border-gray-300 ">
                  <td className="px-[1vw] py-0.9 font-semibold border-r-2 border-gray-300 pb-[0.3vw]">Abhibus Wallet Debit</td>
                  <td className="px-[1vw] py-0.9 text-right font-semibold pb-[0.3vw]"> - {Number(item.NetProfitORLossSummary.abhibus_wallet_debit).toFixed(2)}</td>
                  {/* <p>₹ {item?.base_fare.endsWith('0') ? item.base_fare.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '') : item.base_fare}</p> */}
                </tr>
                
                {/* <hr class="border-t-2 border-dotted border-black ml-3 w-[17vw]" /> */}

              
               
                
                  { item.NetProfitORLossSummary.status==="Profit"?
                  <tr className=" bg-green-500 text-white">
                  <td className="px-[1vw] py-1.5 rounded-bl-lg font-bold text-[1vw]">Net Value</td>
                  <td className="px-[1vw] py-1.5 rounded-br-lg text-right font-bold text-[1vw]">₹ {Number(item.NetProfitORLossSummary.net_value).toFixed(2)}</td>
                </tr>:
                <tr className=" bg-red-500 text-white   ">
                  <td className="px-[1vw] py-1.5 rounded-bl-lg  font-bold text-[1vw]">Net Value</td>
                  <td className="px-[1vw] py-1.5 rounded-br-lg text-right font-bold text-[1vw]">₹ {Number(item.NetProfitORLossSummary.net_value).toFixed(2)}</td>
                </tr>
    }
                
                
                

</tbody>
</table>

</div>
</div>
        
  
  </div>  
      
      ),

    }))

return(
   <>
   <div
        className={`h-[72.3vh] custom-table-container ${
          isRowExpanded ? "mb-[vh]" : ""
        } overflow-y-auto`}
      >
    <Table
            className="custom-table"
            columns={columns}
            dataSource={data}
            tableLayout='fixed'
            pagination={false}
            locale={{ emptyText: "No Data Available" }}
            expandable={{
              expandedRowRender: (record) => (
                <p style={{ margin: 0 }}>{record?.hidden_details}</p>
              ),
            }}
            
            expandRowByClick={true}
            //  onRow={(record) => ({
            //    onClick: () => handleRowClick(record),
            //  })}
            // rowClassName={(row) =>
            //   row?.key === expandedRowKey ? "expanded-row" : ""
            // }
            expandIcon={() => null}
            expandIconColumnIndex={-1}
            expandedRowKeys={expandedRowKey ? [expandedRowKey] : []}
          />
          </div>

            <div className={`${isRowExpanded ? "mb-[10vh]" : ""}`}>
        {getCommission?.length > 10 && (
          <div className=" mt-[1vw]  flex justify-between items-center ">
            <div className="text-[#1f4b7f] flex text-[1.1vw] gap-[0.5vw] ">
              <span>Showing</span>
              <span className="font-bold">
                {currentItems && currentItems?.length > 0 ? (
                  <div>
                    {indexOfFirstItem + 1} -{" "}
                    {indexOfFirstItem + currentItems?.length}
                  </div>
                ) : (
                  "0"
                )}
              </span>
              <span>from</span>
              <span className="font-bold">
                {" "}
                {getCommission?.length > 0 ? getCommission?.length : 0}
              </span>
              <span>data</span>
            </div>
            <div>
              <ReactPaginate
                activePage={activePage}
                itemsCountPerPage={itemsPerPage}
                totalItemsCount={getCommission?.length}
                pageRangeDisplayed={3}
                onChange={handlePageChange}
                itemClass="page-item"
                linkClass="page-link"
                activeClass="active"
                prevPageText={
                  <FontAwesomeIcon icon={faChevronLeft} size="1vw" />
                }
                nextPageText={
                  <FontAwesomeIcon icon={faChevronRight} size="1vw" />
                }
                firstPageText={
                  <FontAwesomeIcon icon={faAngleDoubleLeft} size="1vw" />
                }
                lastPageText={
                  <FontAwesomeIcon icon={faAngleDoubleRight} size="1vw" />
                }
              />
            </div>
          </div>
        )}
      </div>
      
   </>
        
      
)
}
export default Commission;